document.addEventListener('DOMContentLoaded', function () {
    const blockHeroHomepage = document.querySelectorAll('.block-hero-homepage');

    if (blockHeroHomepage.length === 0) return;
    if (typeof gsap === 'undefined') return;

    if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }

    // Loop through each block-hero-homepage section
    blockHeroHomepage.forEach(function (blockHeroHomepage) {
        const blockHeroHomepageHeading = blockHeroHomepage.querySelector('.block-hero-homepage__heading');
        const blockHeroHomepageContent = blockHeroHomepage.querySelector('.block-hero-homepage__content');
        const blockHeroHomepageImage = blockHeroHomepage.querySelector('.block-hero-homepage__picture');
        const blockHeroHomepageVideo = blockHeroHomepage.querySelector('.block-hero-homepage__video');
        const blockHeroHomepageInner = blockHeroHomepage.querySelector('.block-hero-homepage__inner');

        // Check if the heading element exists
        if (blockHeroHomepageHeading) {
            gsap.fromTo(blockHeroHomepageHeading, {
                autoAlpha: 0,
                x: -60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHeroHomepage,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the content element exists
        if (blockHeroHomepageContent) {
            gsap.fromTo(blockHeroHomepageContent, {
                autoAlpha: 0,
                x: 60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHeroHomepage,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        setupBlockHeroHomepageMediaReveal(blockHeroHomepage, blockHeroHomepageImage, blockHeroHomepageInner);
        setupBlockHeroHomepageMediaReveal(blockHeroHomepage, blockHeroHomepageVideo, blockHeroHomepageInner);
    });
});

function setupBlockHeroHomepageMediaReveal(blockHeroHomepage, blockHeroHomepageMedia, blockHeroHomepageInner) {
    if (!blockHeroHomepageMedia || !blockHeroHomepageInner || typeof ScrollTrigger === 'undefined') return;

    const blockHeroHomepageMediaClip = {
        left: 0,
        right: 0,
    };

    const revealAnimation = gsap.fromTo(blockHeroHomepageMediaClip, {
        left: function () {
            return getBlockHeroHomepageMediaClip(blockHeroHomepageInner, 'left');
        },
        right: function () {
            return getBlockHeroHomepageMediaClip(blockHeroHomepageInner, 'right');
        },
    }, {
        left: 0,
        right: 0,
        onUpdate: function () {
            const blockHeroHomepageMediaClipPath = `inset(0px ${blockHeroHomepageMediaClip.right}px 0px ${blockHeroHomepageMediaClip.left}px)`;

            blockHeroHomepageMedia.style.clipPath = blockHeroHomepageMediaClipPath;
            blockHeroHomepageMedia.style.webkitClipPath = blockHeroHomepageMediaClipPath;
        },
        duration: 1,
        ease: 'power3.out',
        paused: true,
    });

    const playRevealAnimation = function () {
        revealAnimation.invalidate().restart();
    };

    ScrollTrigger.create({
        trigger: blockHeroHomepage,
        start: 'top 80%',
        once: true,
        invalidateOnRefresh: true,
        onEnter: function () {
            playRevealAnimation();
        },
    });
}

function getBlockHeroHomepageMediaClip(blockHeroHomepageInner, side) {
    const blockHeroHomepageInnerRect = blockHeroHomepageInner.getBoundingClientRect();
    const blockHeroHomepageLeftClip = Math.max(blockHeroHomepageInnerRect.left, 0);
    const blockHeroHomepageRightClip = Math.max(window.innerWidth - blockHeroHomepageInnerRect.right, 0);

    return side === 'right' ? blockHeroHomepageRightClip : blockHeroHomepageLeftClip;
}
